<template>
    <v-dialog v-model="dialog" max-width="500">
        <v-card>
            <v-card-title>Ajouter un lien</v-card-title>
            <v-card-text>
                <v-text-field v-model="url" label="Entrez l'URL du lien" outlined></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="applyLink">Appliquer</v-btn>
                <v-btn color="error" @click="closeModal">Annuler</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from "vue-facing-decorator";

@Component
export default class LinkWindow extends Vue {
    @Prop({ required: true })
    editor!: any;

    @Prop({ default: null })
    attributes!: any;

    @Prop({ default: false })
    isOpen!: boolean;

    dialog = false;
    url = this.attributes?.href || "";

    @Watch("isOpen")
    onIsOpenChange(newVal: boolean) {
        this.dialog = newVal;
    }

    applyLink() {
        if (this.url) {
            // Vérifie si du texte est sélectionné
            const { from, to } = this.editor.state.selection;
            const hasTextSelected = from !== to;

            if (!hasTextSelected) {
                // Si aucun texte n'est sélectionné, insère un texte par défaut
                this.editor
                    .chain()
                    .focus()
                    .insertContent('<a href="' + this.url + '">Lien</a>')
                    .run();
            } else {
                // Si du texte est sélectionné, applique le lien au texte sélectionné
                this.editor.chain().focus().setLink({ href: this.url }).run();
            }
        }
        this.closeModal();
    }

    closeModal() {
        this.$emit("close");
    }
}
</script>
